'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol['for'] && Symbol['for']("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();
// Named so as not to have collisions with the native Image, which we use here too


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _actionBar = require('./action-bar');

var _actionBar2 = _interopRequireDefault(_actionBar);

var _constants = require('./constants');

var _constants2 = _interopRequireDefault(_constants);

var _hfReactHelper = require('common/utils/hf-react-helper');

var _hfReactHelper2 = _interopRequireDefault(_hfReactHelper);

var _croppable = require('./croppable');

var _croppable2 = _interopRequireDefault(_croppable);

var _extend = require('lodash/object/extend');

var _extend2 = _interopRequireDefault(_extend);

var _throttle = require('lodash/function/throttle');

var _throttle2 = _interopRequireDefault(_throttle);

var _image = require('common/components/image');

var _image2 = _interopRequireDefault(_image);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _ref = _jsx(_reactIntl.FormattedMessage, {
    id: 'signModal.signatureEditArea.controls.contrast.labelText'
});

var SignatureEditArea = _react2['default'].createClass({
    displayName: 'SignatureEditArea',


    propTypes: {
        'app': _react2['default'].PropTypes.object.isRequired,
        'type': _react2['default'].PropTypes.string.isRequired,
        'signature': _react2['default'].PropTypes.object,
        'locales': _react2['default'].PropTypes.array.isRequired,
        'messages': _react2['default'].PropTypes.object.isRequired,
        'isMobile': _react2['default'].PropTypes.bool.isRequired
    },

    //  ----  LIFECYCLE  ----------------------------------

    getInitialState: function getInitialState() {
        return {
            'isSignature': this.props.type === _constants2['default'].TYPE_SIGNATURE,
            'isInitials': this.props.type === _constants2['default'].TYPE_INITIALS,
            'selectedFontIndex': 2,
            'isSpinnerShown': false,
            'contrastValue': this.getContrastMidValue(),
            'degreesValue': 0,
            'isCropped': false,
            'cropX': null,
            'cropY': null,
            'cropWidth': null,
            'cropHeight': null
        };
    },

    componentDidMount: function componentDidMount() {},

    componentDidUpdate: function componentDidUpdate() {},

    //  ----  BEHAVIOR  -----------------------------------

    getContrastMidValue: function getContrastMidValue() {
        return (_constants2['default'].CONTRAST_MAX_THRESHOLD + _constants2['default'].CONTRAST_MIN_THRESHOLD) / 2;
    },

    scaleSignatureToFit: function scaleSignatureToFit(origDims, restrictDims) {
        var origDims = (0, _extend2['default'])({}, origDims);

        origDims.ratio = parseFloat(origDims.width / origDims.height);

        if (origDims.width > origDims.height) {

            origDims.width = restrictDims.width;
            origDims.height = parseInt(origDims.width / origDims.ratio, 10);

            if (origDims.height > restrictDims.height) {

                origDims.height = restrictDims.height;
                origDims.width = parseInt(origDims.height * origDims.ratio, 10);
            }
        } else {
            origDims.height = restrictDims.height;
            origDims.width = parseInt(origDims.height * origDims.ratio, 10);

            if (origDims.width > restrictDims.width) {

                origDims.width = restrictDims.width;
                origDims.height = parseInt(origDims.width / origDims.ratio, 10);
            }
        }

        return origDims;
    },

    // Stores prefeched images
    images: {},

    /*
    * Throttled for performance. This may need to be adjusted in the future to > 1s
    */

    prefetchImages: (0, _throttle2['default'])(function () {
        this._prefetchImages();
    }, 1000),

    /*
    * Private prefetch images function
    *
    * Simply gets and stores all contrast variants on load or rotate.
    * The browser will take care of using the cached images instead of reloading from
    * the server each time.
    */

    _prefetchImages: function _prefetchImages() {
        if (!this.props.signature) {
            return;
        }

        var guid = this.props.signature.guid;
        var degrees = this.state.degreesValue || 0;
        var contrastStep = _constants2['default'].CONTRAST_MIN_THRESHOLD;

        while (contrastStep <= _constants2['default'].CONTRAST_MAX_THRESHOLD) {

            var key = 'c' + contrastStep + 'd' + degrees;

            // Don't even need to check if already set - we want to overwrite on
            // subsequent uploads
            this.images[key] = new window.Image();
            this.images[key].src = this.props.signature.getUrl(contrastStep, degrees);

            contrastStep += _constants2['default'].CONTRAST_STEP_AMOUNT;
        }
    },

    renderSignatureImage: function renderSignatureImage() {

        this.prefetchImages();

        var threshold = this.state.contrastValue || 100;
        var degrees = this.state.degreesValue || 0;

        var url;
        var guid;
        if (this.props.signature) {
            url = this.props.signature.getUrl(threshold, degrees);
            guid = this.props.signature.guid;
        }

        var style = {};

        // Hardcoded to preview container area size, with 2px padding
        var previewAreaDimensions = {
            'width': 398,
            'height': 120
        };

        if (this.props.signature) {

            var imageDims = {
                'width': this.props.signature.width,
                'height': this.props.signature.height
            };

            // flip dimensions if rotating vs saved wh
            if (degrees == 90 || degrees == 270) {
                imageDims.height = this.props.signature.width;
                imageDims.width = this.props.signature.height;
            }

            style = this.scaleSignatureToFit(imageDims, previewAreaDimensions);
        }

        style.backgroundImage = 'url(' + url + ')';
        style.backgroundSize = '100%';

        return _react2['default'].createElement('div', { className: 'm-sign-modal--signature-edit-area--preview--image',
            ref: 'uploadSignaturePreviewImage',
            guid: guid,
            style: style });
    },

    rotateSignature: function rotateSignature() {
        var self = this;
        this.props.signature.rotate(function () {
            self.incrementDegrees();
            self.render();
        });
    },

    // Reset to 0 if we come full circle
    incrementDegrees: function incrementDegrees() {
        var newValue;

        if (this.state.degreesValue + _constants2['default'].ROTATE_DEGREES_AMOUNT >= 360) {
            newValue = 0;
        } else {
            newValue = this.state.degreesValue + _constants2['default'].ROTATE_DEGREES_AMOUNT;
        }

        this.setState({
            'degreesValue': newValue
        });
    },

    adjustContrast: function adjustContrast(event) {
        this.setState({
            'contrastValue': event.target.value
        });
    },

    setCropBounds: function setCropBounds(cropRect) {

        var imageBounds = this.refs.uploadSignaturePreviewImage.getBoundingClientRect();

        var preScaledCrop = {
            x: cropRect.left - imageBounds.left,
            y: cropRect.top - imageBounds.top,
            width: cropRect.width,
            height: cropRect.height
        };

        if (preScaledCrop.width > 0 && preScaledCrop.height > 0) {

            var originalImageBounds = { width: this.props.signature.width, height: this.props.signature.height };

            var scaledParams = this.scaleCrop(imageBounds, originalImageBounds, preScaledCrop);

            this.setState({
                'isCropped': true,
                'cropX': scaledParams.x,
                'cropY': scaledParams.y,
                'cropWidth': scaledParams.width,
                'cropHeight': scaledParams.height
            });
        } else {
            this.setState({
                'isCropped': false
            });
        }
    },

    scaleCrop: function scaleCrop(imageScaledSize, imageOriginalSize, cropSize) {

        var scaledCropParams = {};

        var scaleY = parseFloat(imageOriginalSize.height / imageScaledSize.height);
        var scaleX = parseFloat(imageOriginalSize.width / imageScaledSize.width);
        var scaledPositionX = 0;
        var scaledPositionY = 0;
        var scaledWidth = imageOriginalSize.width;
        var scaledHeight = imageOriginalSize.height;

        scaledPositionX = parseInt(scaleX * cropSize.x, 10);
        scaledPositionY = parseInt(scaleY * cropSize.y, 10);
        scaledWidth = parseInt(scaleX * cropSize.width, 10);
        scaledHeight = parseInt(scaleY * cropSize.height, 10);

        if (scaledWidth > imageOriginalSize.width) {
            scaledWidth = imageOriginalSize.width;
        }

        if (scaledWidth + scaledPositionX > imageOriginalSize.width) {
            scaledWidth = imageOriginalSize.width - scaledPositionX;
        }

        if (scaledHeight > imageOriginalSize.height) {
            scaledHeight = imageOriginalSize.height;
        }

        if (scaledHeight + scaledPositionY > imageOriginalSize.height) {
            scaledHeight = imageOriginalSize.height - scaledPositionY;
        }

        scaledCropParams.x = scaledPositionX;
        scaledCropParams.y = scaledPositionY;
        scaledCropParams.width = scaledWidth;
        scaledCropParams.height = scaledHeight;

        return scaledCropParams;
    },

    //  ----  RENDERING  ----------------------------------

    renderControls: function renderControls() {

        var type = this.props.type;

        var contrastControl = _jsx('div', {
            className: 'm-sign-modal--signature-edit-area--controls--contrast'
        }, void 0, _jsx('input', {
            type: 'range',
            min: _constants2['default'].CONTRAST_MIN_THRESHOLD,
            max: _constants2['default'].CONTRAST_MAX_THRESHOLD,
            step: _constants2['default'].CONTRAST_STEP_AMOUNT,
            defaultValue: this.getContrastMidValue(),
            onMouseUp: this.adjustContrast
        }), _jsx('div', {}, void 0, _ref));

        var rotationControl = _jsx('div', {
            className: 'm-sign-modal--signature-edit-area--controls--rotate',
            onClick: this.rotateSignature
        }, void 0, _jsx(_image2['default'], {
            url: require('./sigcreation_modal_rotate_clockwise_@2x.png')
        }), _jsx('div', {}, void 0, _jsx(_reactIntl.FormattedMessage, {
            id: 'signModal.signatureEditArea.controls.rotate.labelText',
            values: { type: type }
        })));

        return _jsx('div', {
            className: 'm-sign-modal--signature-edit-area--controls'
        }, void 0, contrastControl, rotationControl);
    },

    render: function render() {

        var spinner;

        var type = this.props.type;

        var instructions = _jsx('div', {
            className: 'm-sign-modal--signature-edit-area--instructions'
        }, void 0, _jsx(_reactIntl.FormattedMessage, {
            id: 'signModal.signatureEditArea.instructions',
            values: { type: type }
        }));

        var previewAndCrop = _react2['default'].createElement(
            _croppable2['default'],
            _extends({}, this.props, {
                restrictToParent: true,
                callback: this.setCropBounds,
                containerClassName: 'm-sign-modal--signature-edit-area--preview' }),
            this.renderSignatureImage()
        );

        return _jsx('div', {
            className: 'm-sign-modal--signature-edit-area'
        }, void 0, instructions, previewAndCrop, this.renderControls());
    }
});

module.exports = SignatureEditArea;


/*****************
 ** WEBPACK FOOTER
 ** ./src/signer/components/common/signature-modal/signature-edit-area.jsx
 ** module id = 686
 ** module chunks = 0
 **/